export const mentorData = [
  {
    id: "Dr.Kamakoti_Veezhinathan",
    name: "Dr.Kamakoti Veezhinathan",
    profile: "/assets/mentors/kk.jpg",
    desg: "Professor of Computer Science & Engineering, IIT Madras",
    desc: (
      <div>
        Kamakoti Veezhinathan is a Professor of Computer Science & Engineering,
        IIT Madras. <br />
        <br />
        He was also the Chairman of the Artificial Intelligence Task Force
        constituted by the Ministry of Commerce and Industry, Government of
        India. He specializes in the area of Computer Architecture, Information
        Security and VLSI Design. He also heads the Microprocessor Development
        Program and the Information Security Education and Awareness Program
        funded by the Ministry of Electronics and Information Technology,
        Government of India. <br />
        <br />
        Dr.V. Kamakoti received the M.S. degree and the Ph.D. degree in computer
        science and engineering from IIT Madras, Chennai, India. He is currently
        a Professor with the Department of Computer Science and Engineering and
        Associate Dean at ICSR,IIT Madras. He has more than 15 years of
        experience in computer systems development and specializes in the area
        of computer architecture, CAD for VLSI, and high performance computing.
        Dr. Kamakoti took SHAKTI processor initiative which aim to break the
        barrier between Academia and Industry by providing open-source Processor
        and SoC designs. He has authored a number of research papers that have
        been published in various international journals and in the PROCEEDINGS
        of many scientific conferences. <br />
        <br />
        Dr.Kamakoti also has interest in writing literature and has published
        Ganiporiyum Adipadiyum, a book in Tamil released in 1992.Dr. Kamakoti
        received DRDO Academic Excellence Award instituted by DRDO in
        recognition of the contribution from Academicians to various programs of
        DRDO. Recently, Dr. Kamakoti was awarded Techno Visionary Award, which
        is a lifetime achievement award given to an Indian academician, who made
        significant contributions to the field of Electronics and Semiconductor
        through research and development.
      </div>
    ),
  },
  {
    id: "Shri.Vishal_Kanvaty",
    name: "Shri.Vishal Kanvaty",
    profile: "/assets/mentors/vishal.jpg",
    desg: "Chief of Innovation at NPCI",
    desc: (
      <div>
        Vishal Kanvaty is Chief of Innovation at NPCI. He has around 20yrs in
        Payment Industry and has expertise in Payments and Retail Banking. He
        also has good knowledge on Blockchain and has ran a startup on
        Blockchain. His areas of interest include payments, credit cards, retail
        banking and impact of technology on Banking. His recent focus has been
        in the area how payments can be transformed in India leveraging various
        technologies like Blockchain, AI/ML and API’s. <br />
        <br />
        Mr Vishal has been instrumental in seeing the growth of various products
        at NPCI including UPI/Rupay/ NETC/AEPS etc. He is very passionate about
        digital payments initiative.
      </div>
    ),
  },
  {
    id: "Shri.Mahesh_Ramachandran",
    name: "Shri.Mahesh Ramachandran",
    profile: "/assets/mentors/mahesh.jpg",
    desg: "Social Entrepreneur turned investor",
    desc: (
      <div>
        Mahesh Ramachandran is a successful Serial and Social Entrepreneur
        turned investor. <br />
        <br />
        Mahesh is a distinguished Sloan Fellow of London Business School. Mahesh
        is Leadership Council and Programme Management Group member of FinBlue
        FinTech Centre of Excellence set up by Ministry of Electronics and
        Information Technology, Government of India at STPI, Chennai. Mahesh is
        Managing Partner of Pontaq India, a cross border venture capital
        Innovation Fund. Mahesh is an angel investor, mentor, independent
        director supporting innovative startups and helps build the ecosystem.
        Mahesh is a member of The Chennai Angels, The Mumbai Angels, Keiretsu,
        Native Angels and many other angel network. <br />
        <br />
        Mahesh chairs TiE FinTech Special Interest Group and is in the Governing
        Council of TiE Chennai Mahesh is the founder of Commonwealth Inclusive
        Growth Services Ltd which operates in over 30,000 locations across 27
        states in India. It handles over 10,000 crores of government to citizen
        benefits every year servicing over 5 million rural customers. Mahesh is
        also a visiting faculty of Indian School of Business,Bennett University
        and National Police Academywhere he teaches digital transformation,
        leveraging social media and entrepreneurship. <br />
        <br />
        Mahesh holds an MBA from University of Westminster, Sloan Masters in
        Leadership & Strategy (Distinguished Sloan Fellow of London Business
        School) from University of London. Mahesh heads the London Business
        School Alumni club in Chennai. Mahesh is part of Stanford SEED
        Transformation programme and acts as Mentor in Stanford Spark
        initiative. Mahesh Ramachandran brings with him several decades of rich
        & varied experience in the field of Entrepreneurship, Investing,
        FinTech, Financial Inclusion, Rural Marketing,Modelling & Simulation,
        Leadership, Mentoring & Governance. Mahesh Ramachandran entrepreneurial
        ventures include peer to peer foreign exchange portal, targeted
        advertisement and digital payment solution and financial inclusion.
        <br />
        <br />
        Mahesh hails from Thanjavur, South India and loves Coffee, Carnatic
        Music and Comics.
      </div>
    ),
  },
  {
    id: "Shri.Pradeep_Kumar_S",
    name: "Shri.Pradeep Kumar S",
    profile: "/assets/mentors/pradeep.jpg",
    desg: "Director",
    desc: (
      <div>
        Financial Technologist for 19+ years, spending almost half the time in
        London working for Citigroup’s Capital Markets, and afterwards for
        NatWest(Formerly Known as RBS) Technology India in various leadership
        roles. Currently leads NatWest Group’s Technology Transformation
        initiatives driven from India for the bank’s global Retail/ Commercial/
        Corporate/ Private banking businesses. He is also India Lead of the
        bank’s Sustainable Futures Network, a Certified Coach, Mentor, and
        Diversity & Inclusion Champion. Charter Member of The Indus Entrepreneur
        (TiE), member of British Business Group and connected to British Deputy
        High Commission, Chennai to help collaboration between UK and India,
        specifically for FinTechs.
        <br />
        <br /> Aspiring writer, with work published in literary magazines.MBA
        from London Business School, University of London, Post-Graduate in
        Software Engineering, and Bachelors of Electrical Engineering.
      </div>
    ),
  },
  {
    id: "Shri.M.S.Bharath",
    name: "Shri.M. S. Bharath",
    profile: "/assets/mentors/bharat.jpg",
    desg: "Senior Partner",
    desc: (
      <div>
        Bharath a Senior Partner at Anand and Anand, India with almost 2 decades
        of practice in intellectual property law (trademarks, copyright,
        designs, patents, confidential information, information technology and E
        Commerce). He is sought after for his Business side approach and
        Strategy from the early stage of ideation, protection and enforcement of
        IP rights not only in India but across foreign jurisdictions as well.
        His practice includes Litigation before Courts, Opposition,
        cancellation, arbitration and other proceedings before various IPR
        Tribunals including Trademarks, Designs, Copyright Geographical
        Indications, Intellectual Property Appellate Board (IPAB). He has been
        the lead counsel in numerous proceedings before the Indian Courts and IP
        Appeal Board with several reported decisions to his credentials.
        <br />
        <br /> Over the years he has advised clients of varied sizes including
        Start-Ups, Celebrities, Multinationals managing their large portfolios
        in varied field of Pharma, Entertainment, Telecom, Footwear, Luxury
        products, Tobacco, Alcoholic Beverages, Automobile and Consumer Goods.
        He counsels clients on assignments, licensing, co-existence, franchise
        and other transactions related to intellectual property and currently
        oversees franchise portfolios of clients in the fields of restaurants,
        salons, education. He has been a speaker at and organized various
        Universities, national and international forums. He was Member of the
        group set up by CII and Tamil Nadu Technological Development & Promotion
        Council (TNTDPC) to work on “Study on Mapping the IP landscape in Tamil
        Nadu” whose report can be found{" "}
        <a
          rel="noreferrer noopener"
          target="_blank"
          href="
        http://www.tntdpc.com/assets/download/IPR_TNTDPCReport_8May2015.pdf
        "
        >
          here
        </a>
        <br />
        <br /> He was instrumental in successfully restraining unauthorized use
        of the famous Tirupati Laddu, a registered GI in India apart from
        prosecuting GI applications towards grant for various national and
        international applicants in India including those for Baidagi Chillies,
        Tequila and Scotch.
        <br />
        <br /> Bharath often uses mediation and conciliation as means of
        resolving large scale conflicts. One such resolution involved as many as
        250 oppositions, 2 Court litigations, 3 criminal proceedings and a few
        freehold properties. One of his clients, a leading actor sought his name
        on screen to play the role of a lawyer in a critically acclaimed movie.
        <br />
        <br /> Admitted: <br />
        Bar Council of India, Delhi High Court Bar Association & Madras Bar
        Association
        <br />
        <br /> Recognitions: <br />
        Bharath has been endorsed by BRIC: EXPERT GUIDES as IP Expert from
        India; Asia Law for Intellectual Property identifying him as one of the
        leading IP counsels in India every year since 2013; Asia IP Expert Guide
        2013 recognized Bharath as a leading IP Advisor.
      </div>
    ),
  },
];
